import React, { useState } from 'react';
import { Blurhash } from 'react-blurhash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';
import { BASE_URI } from 'utils/constants';

const ImageWrapper = styled.div`
  position: relative;
`;

const StyledBlurhash = styled(Blurhash)`
  z-index: 20;
  position: absolute !important;
  top: 0;
  left: 0;
`;

interface IOptimizedImageProps {
  image: { path: string; blurhash: string };
  height?: string;
  width?: string;
}

export default function LazyLoadImageHash(props: IOptimizedImageProps) {
  const { image, height, width } = props;

  const [isLoaded, setLoaded] = useState(false);
  const [isLoadStarted, setLoadStarted] = useState(false);

  const handleLoad = () => {
    setLoaded(true);
  };

  const handleLoadStarted = () => {
    setLoadStarted(true);
  };

  const url = `${BASE_URI}${image.path}`;

  return (
    <ImageWrapper>
      <LazyLoadImage
        key={image.path}
        src={url}
        width={width}
        height={height}
        onLoad={handleLoad}
        beforeLoad={handleLoadStarted}
        className='object-cover'
        style={{
          minWidth: width,
          minHeight: height,
        }}
      />

      {!isLoaded && isLoadStarted && (
        <StyledBlurhash
          hash={image.blurhash}
          width={width}
          height={height}
          resolutionX={32}
          resolutionY={32}
          punch={1}
        />
      )}
    </ImageWrapper>
  );
}
